import { Injectable } from '@angular/core';
import { UserInfo } from '@models/user-info.model';
import { HeaderStateModel } from '@services/app-state-service/models/header-state.model';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  private zoom = 1;
  private headerState = new BehaviorSubject<HeaderStateModel>(new HeaderStateModel());
  private userInfoState = new BehaviorSubject<UserInfo | null>(null);
  private selectedHeroState = new BehaviorSubject<string | null>(null);

  setHeaderState(newState: HeaderStateModel = {}): void {
    this.headerState.next({
      ...new HeaderStateModel(),
      ...newState,
    });
  }

  getHeaderStateObservable(): Observable<HeaderStateModel> {
    return this.headerState.asObservable();
  }

  setZoom(zoom: number) {
    this.zoom = zoom;
  }

  getZoom() {
    return this.zoom;
  }

  setUserInfo(userInfo: UserInfo | null) {
    this.userInfoState.next(userInfo);
  }

  getUserInfo(): Observable<UserInfo | null> {
    return of(this.userInfoState.getValue());
  }

  setSelectedHero(selectedHero: string) {
    this.selectedHeroState.next(selectedHero);
  }

  getSelectedHero(): Observable<string | null> {
    return this.selectedHeroState.asObservable();
  }
}
